import { render, staticRenderFns } from "./AtomText.vue?vue&type=template&id=7a66d300&"
import script from "./AtomText.vue?vue&type=script&lang=js&"
export * from "./AtomText.vue?vue&type=script&lang=js&"
import style0 from "./AtomText.vue?vue&type=style&index=0&id=7a66d300&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports